module.exports = __webpack_public_path__ + "img/other_pic08.2e40254c.png";